<div class="page-section series-form-page">
    <div class="app-l-page__navigation">
        <div class="app-l-page__previous">
            <button
                type="button"
                class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                [routerLink]="['/admin/assessments-listing']"
                aria-label="Close">
                <svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
            </button>
        </div>
        <div class="app-l-page__breadcrumbs">
            <ul class="breadcrumbs-list">
                <li class="breadcrumbs-list-item">
                    <a [routerLink]="['/admin/assessments-listing']"
                        >Assessments</a
                    >
                </li>
                <li class="breadcrumbs-list-item app-l-current-page">
                    {{ title }}
                </li>
            </ul>
        </div>
    </div>
    <div class="page-section-content">
        <page-loader *ngIf="!isLoaded"></page-loader>
        <div *ngIf="isLoaded">
            <form
                novalidate
                [formGroup]="assessmentEditForm"
                (ngSubmit)="doSave()">
                <div class="form-wrapper-80">
                    <div class="app-c-form-group">
                        <label class="app-c-form--label" for="quizType"
                            >Quiz Type</label
                        >
                        <input
                            class="app-c-form-control"
                            type="text"
                            formControlName="quizType"
                            id="quizType" />
                        <div
                            class="error-message"
                            *ngIf="
                                submitButtonPressed &&
                                assessmentEditForm.controls['quizType'].errors
                                    ?.required
                            ">
                            The assessment needs a quiz type.
                        </div>
                    </div>

                    <div class="app-c-form-group">
                        <label class="app-c-form--label" for="comment"
                            >Quiz Name</label
                        >
                        <input
                            class="app-c-form-control"
                            type="text"
                            formControlName="comment"
                            id="comment" />
                        <div
                            class="error-message"
                            *ngIf="
                                f.comment.touched && f.comment.errors?.required
                            ">
                            The assessment needs a comment.
                        </div>
                    </div>

                    <div class="check-box-container">
                        <label>
                            <input
                                type="checkbox"
                                formControlName="default"
                                [attr.disabled]="
                                    mode == 'update' &&
                                    assessment?.assessmentKey ==
                                        'mentalwellbeing'
                                        ? true
                                        : null
                                " />
                            Default?
                        </label>
                    </div>
                    <div class="check-box-container">
                        <label>
                            <input
                                type="checkbox"
                                formControlName="active"
                                [attr.disabled]="
                                    mode == 'update' &&
                                    assessment?.assessmentKey ==
                                        'mentalwellbeing'
                                        ? true
                                        : null
                                " />
                            Active?
                        </label>
                    </div>

                    <div id="ressourceSection">
                        <h2>Questions</h2>

                        <div *ngIf="assessment && assessment.questions">
                            <div class="app-c-accordion">
                                <details
                                    class="app-c-expansion-panel-container"
                                    *ngFor="
                                        let question of questions.controls;
                                        let i = index
                                    "
                                    [formGroup]="getQuestion(i)">
                                    <summary class="app-c-expansion-panel">
                                        <div class="title_conatiner">
                                            <span
                                                class="app-c-expansion-panel__title"
                                                >Question {{ i + 1 }}</span
                                            >
                                            <span
                                                class="app-c-expansion-panel__description">
                                                {{ question.value.comment }}
                                            </span>
                                        </div>

                                        <span
                                            class="app-c-expansion-panel__description">
                                            <svg-icon
                                                icon="angle-right"
                                                class="app-c-expansion-panel__arrow-icon"></svg-icon>
                                        </span>
                                    </summary>
                                    <ng-container padding>
                                        <div class="item-remove-btn">
                                            <a
                                                class="remove"
                                                tabindex="0"
                                                (click)="onRemoveQuestion(i)"
                                                (keypress)="onRemoveQuestion(i)"
                                                ><img
                                                    alt=""
                                                    src="./assets/img/icons-svg/trash.svg"
                                            /></a>
                                        </div>
                                        <div class="app-c-form-group">
                                            <label class="app-c-form--label"
                                                >Comment</label
                                            >
                                            <input
                                                class="app-c-form-control"
                                                type="text"
                                                formControlName="comment" />
                                            <div
                                                class="error-message"
                                                *ngIf="
                                                    getQuestion(i).controls[
                                                        'comment'
                                                    ].touched &&
                                                    getQuestion(i).controls[
                                                        'comment'
                                                    ].errors?.required
                                                ">
                                                The question needs a comment
                                            </div>
                                        </div>

                                        <div class="app-c-form-group">
                                            <label class="app-c-form--label"
                                                >Group</label
                                            >
                                            <input
                                                class="app-c-form-control"
                                                type="text"
                                                formControlName="group" />
                                        </div>

                                        <div class="check-box-container">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    formControlName="required" />
                                                Required
                                            </label>
                                        </div>

                                        <div class="app-c-form-group">
                                            <label class="app-c-form--label"
                                                >Sort Order</label
                                            >
                                            <input
                                                class="app-c-form-control"
                                                type="number"
                                                formControlName="sortOrder"
                                                pattern="^[0-9]*$" />
                                        </div>

                                        <div class="app-c-form-group">
                                            <label class="app-c-form--label"
                                                >Question Type</label
                                            >
                                            <!--
                                                [ngValue] keeps the question type a number in the
                                                form control (it is posted as an int). That rules out
                                                reading $event.target.value, which is Angular's
                                                "index: value" encoding, so the dependent section
                                                below reads the control directly instead.
                                            -->
                                            <select
                                                class="app-c-form-control"
                                                formControlName="type">
                                                <option
                                                    [ngValue]="null"
                                                    disabled>
                                                    Select a type
                                                </option>
                                                <option
                                                    *ngFor="
                                                        let questionType of questionTypes
                                                    "
                                                    [ngValue]="
                                                        questionType.value
                                                    ">
                                                    {{ questionType.label }}
                                                </option>
                                            </select>
                                        </div>

                                        <div class="check-box-container">
                                            <label class="toggle-switch">
                                                <input
                                                    type="checkbox"
                                                    formControlName="tabulate" />
                                                <span
                                                    class="toggle-slider"></span>
                                            </label>
                                            <span class="toggle-label"
                                                >Tabulate score?</span
                                            >
                                        </div>
                                        <div class="check-box-container">
                                            <label class="toggle-switch">
                                                <input
                                                    type="checkbox"
                                                    formControlName="active" />
                                                <span
                                                    class="toggle-slider"></span>
                                            </label>
                                            <span class="toggle-label"
                                                >Active?</span
                                            >
                                        </div>

                                        <div
                                            *ngIf="
                                                getQuestion(i).controls['type']
                                                    .value === 8
                                            "
                                            class="validation-fields">
                                            <div
                                                class="app-c-form-group inline-field">
                                                <label class="app-c-form--label"
                                                    >Min</label
                                                >
                                                <input
                                                    class="app-c-form-control"
                                                    type="number"
                                                    pattern="^[0-9]*$"
                                                    formControlName="min" />
                                            </div>
                                            <div
                                                class="app-c-form-group inline-field">
                                                <label class="app-c-form--label"
                                                    >Max</label
                                                >
                                                <input
                                                    class="app-c-form-control"
                                                    type="number"
                                                    pattern="^[0-9]*$"
                                                    formControlName="max" />
                                            </div>
                                        </div>
                                    </ng-container>

                                    <ng-container formArrayName="options">
                                        <div class="app-c-accordion">
                                            <details
                                                *ngFor="
                                                    let option of getOptions(i)
                                                        .controls;
                                                    let r = index
                                                "
                                                [formGroupName]="r"
                                                class="app-c-expansion-panel-container option-panel-container">
                                                <summary
                                                    class="app-c-expansion-panel">
                                                    <span
                                                        class="app-c-expansion-panel__title"
                                                        >Option
                                                        {{ r + 1 }}</span
                                                    >

                                                    <span
                                                        class="app-c-expansion-panel__description">
                                                        <svg-icon
                                                            icon="angle-right"
                                                            class="app-c-expansion-panel-option__arrow-icon"></svg-icon>
                                                    </span>
                                                </summary>
                                                <ng-container padding>
                                                    <div
                                                        class="item-remove-btn">
                                                        <a
                                                            class="remove"
                                                            tabindex="0"
                                                            (click)="
                                                                removeOption(
                                                                    i,
                                                                    r
                                                                )
                                                            "
                                                            (keypress)="
                                                                removeOption(
                                                                    i,
                                                                    r
                                                                )
                                                            "
                                                            ><img
                                                                alt=""
                                                                src="./assets/img/icons-svg/trash.svg"
                                                        /></a>
                                                    </div>
                                                    <div
                                                        class="form-section-flex">
                                                        <div
                                                            class="form-column">
                                                            <div
                                                                class="app-c-form-group">
                                                                <label
                                                                    class="app-c-form--label"
                                                                    >Option
                                                                    Value</label
                                                                >
                                                                <input
                                                                    class="app-c-form-control"
                                                                    type="number"
                                                                    formControlName="optionValue"
                                                                    pattern="^[0-9]*$" />
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="form-column">
                                                            <div
                                                                class="app-c-form-group">
                                                                <label
                                                                    class="app-c-form--label"
                                                                    >Sort
                                                                    Order</label
                                                                >
                                                                <input
                                                                    class="app-c-form-control"
                                                                    type="number"
                                                                    formControlName="sortOrder"
                                                                    pattern="^[0-9]*$" />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="app-c-form-group">
                                                        <label
                                                            class="app-c-form--label"
                                                            >Comment</label
                                                        >
                                                        <input
                                                            class="app-c-form-control"
                                                            type="text"
                                                            formControlName="comment" />
                                                        <div
                                                            class="error-message"
                                                            *ngIf="
                                                                submitButtonPressed &&
                                                                getOption(i, r)
                                                                    .controls[
                                                                    'comment'
                                                                ].errors
                                                                    ?.required
                                                            ">
                                                            The option needs a
                                                            comment
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </details>
                                        </div>
                                        <a
                                            tabindex="0"
                                            *ngIf="
                                                (question.value.type !== 5 ||
                                                    question.value.type ===
                                                        '5') &&
                                                (question.value.type !== 6 ||
                                                    question.value.type === '6')
                                            "
                                            class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon"
                                            (click)="addOption(i, {})"
                                            (keypress)="addOption(i, {})"
                                            ><svg-icon
                                                icon="plus"
                                                alt="plus"></svg-icon
                                            ><span>Add Option</span></a
                                        >
                                    </ng-container>
                                </details>
                            </div>
                            <a
                                tabindex="0"
                                class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon"
                                (click)="addQuestion({})"
                                (keypress)="addQuestion({})"
                                ><svg-icon icon="plus" alt="plus"></svg-icon
                                ><span>Add Question</span></a
                            >
                        </div>
                    </div>
                </div>
            </form>
            <div class="fixed-footer">
                <p
                    class="red"
                    *ngIf="
                        submitButtonPressed &&
                        !assessmentEditForm.valid &&
                        errors === ''
                    ">
                    Please check the errors
                </p>
                <p class="red">{{ errors }}</p>
                <button
                    type="button"
                    class="app-c-btn app-c-btn--primary app-c-btn--curve"
                    (click)="doSave()">
                    Save
                </button>
            </div>
        </div>
    </div>
</div>
